// Client-side Orlando place/hotel search via the Mapbox Search Box API.
// Runs in the browser so it uses REACT_APP_MAPBOX_TOKEN and sends a Referer,
// which passes Mapbox token URL restrictions (server-side calls can't).
const TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

// Orlando metro bias: proximity centre + bbox covering MCO, I-Drive, Lake Buena
// Vista, Disney/Universal, Kissimmee, Davenport/ChampionsGate, Winter Park.
const PROXIMITY = "-81.42,28.48";
const BBOX = "-82.30,27.80,-80.80,29.10";
const LODGING = new Set(["hotel", "lodging", "motel", "resort", "hostel", "inn", "bed_and_breakfast", "guest_house"]);
const LODGING_WORDS = ["hotel", "resort", "inn", "suites", "lodge", "motel", "hostel", "residences", "villas"];

function rank(featType, cats, nameL) {
  const has = (arr) => arr.some((c) => cats.has(c));
  if (has([...LODGING]) || LODGING_WORDS.some((w) => nameL.includes(w))) return 0;
  if (cats.has("airport") || nameL.includes("airport")) return 1;
  if (featType === "poi") return 2;
  if (featType === "address" || featType === "street") return 3;
  return 4;
}

export async function searchPlaces(q) {
  if (!TOKEN) throw new Error("Map search is not configured.");
  const params = new URLSearchParams({
    q, access_token: TOKEN, language: "en", country: "us",
    proximity: PROXIMITY, bbox: BBOX, limit: "10",
    types: "poi,address,place,postcode,locality,neighborhood,street",
  });
  const res = await fetch(`https://api.mapbox.com/search/searchbox/v1/forward?${params}`);
  if (!res.ok) throw new Error(`search_${res.status}`);
  const data = await res.json();
  const out = [];
  const seen = new Set();
  for (const f of data.features || []) {
    const p = f.properties || {};
    const pid = p.mapbox_id;
    if (!pid || seen.has(pid)) continue;
    seen.add(pid);
    const coords = (f.geometry || {}).coordinates || [];
    if (coords[0] == null) continue;
    const ctx = p.context || {};
    const cats = new Set(p.poi_category || []);
    const name = p.name || "";
    out.push({
      label: name,
      address: p.full_address || p.place_formatted || "",
      city: (ctx.place || {}).name || "",
      state: (ctx.region || {}).region_code || "",
      lat: coords[1], lng: coords[0],
      place_id: pid,
      airport: cats.has("airport") || name.toLowerCase().includes("airport"),
      _rank: rank(p.feature_type || "", cats, name.toLowerCase()),
    });
  }
  out.sort((a, b) => a._rank - b._rank);
  out.forEach((x) => delete x._rank);
  return out;
}
